import { render, staticRenderFns } from "./SparePartTaskIdGridModal.vue?vue&type=template&id=b85a2ef8&scoped=true"
import script from "./SparePartTaskIdGridModal.vue?vue&type=script&lang=ts"
export * from "./SparePartTaskIdGridModal.vue?vue&type=script&lang=ts"
import style0 from "./SparePartTaskIdGridModal.vue?vue&type=style&index=0&id=b85a2ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85a2ef8",
  null
  
)

export default component.exports